// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"352":"008be910","1986":"09b2326b","2991":"69900d86","7147":"890bf816"}[chunkId] + ".chunk.css";
};